export default __webpack_public_path__ + "static/media/yes.1d225f09.svg";